import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changeset from 'ember-changeset/helpers/changeset';
import t from 'ember-intl/helpers/t';
import add from 'ember-math-helpers/helpers/add';
import ModelList from 'parog-web/components/model-list';
import Dropdown from 'ui-kit/components/changeset/dropdown';
import DatePicker from '../../changeset/date-picker';

interface Signature {
  Args: {
    changeset: EmberChangeset;
  };
}

export default class TreatmentHistoryEditionFormBreastCancerFormHormonotherapySectionComponent extends Component<Signature> {
  get hormonotherapyTypes() {
    return ['anti-aromatase', 'femara', 'tamoxifen', 'sequential'];
  }

  get #hormonotherapies() {
    return this.args.changeset.get('hormonotherapies');
  }

  onChangesetUpdate = (changeset: EmberChangeset) => {
    changeset.execute();
    this.#setAsDirty();
  };

  #setAsDirty() {
    this.args.changeset.set(
      'hormonotherapies',
      [].concat(this.#hormonotherapies)
    );
  }

  <template>
    <h2 class='ui dividing header'>Hormonothérapie</h2>

    <div class='field'>
      <div class='field' id='hormonotherapies' data-test-hormonotherapy-list>
        <ModelList
          @model={{@changeset}}
          @propertyName='hormonotherapies'
          @addButtonTitle='Ajouter une hormonothérapie'
          as |Item|
        >
          {{#let (changeset Item.item) as |hoormonotherapyChangeset|}}
            <div
              class='ui segment'
              data-test-hormonotherapy-list-item={{Item.index}}
            >
              <h3 class='ui dividing header'>Hormonothérapie
                {{add Item.index 1}}</h3>
              <i
                class='trash icon absolute right-0 top-0 m-2 opacity-[0.5]'
                role='button'
                {{on 'click' Item.destroy}}
              >
              </i>
              <div>
                <div class='field'>
                  <DatePicker
                    @labelName='Date de début'
                    @propertyName='startDate'
                    @changeset={{hoormonotherapyChangeset}}
                    @onChangesetUpdate={{this.onChangesetUpdate}}
                  />
                </div>
                <div class='field'>
                  <DatePicker
                    @labelName='Date de fin'
                    @propertyName='endDate'
                    @changeset={{hoormonotherapyChangeset}}
                    @onChangesetUpdate={{this.onChangesetUpdate}}
                  />
                </div>
                <div class='field'>
                  <Dropdown
                    @labelName='Type d’hormonothérapie'
                    @propertyName='type'
                    @changeset={{hoormonotherapyChangeset}}
                    @onChangesetUpdate={{this.onChangesetUpdate}}
                    as |dropdown|
                  >
                    {{#each this.hormonotherapyTypes as |hormonotherapyType|}}
                      <dropdown.Item
                        @key={{hormonotherapyType}}
                        @value={{t
                          (concat 'hormonotherapy-type.' hormonotherapyType)
                        }}
                      />
                    {{/each}}
                  </Dropdown>
                </div>
              </div>
            </div>
          {{/let}}
        </ModelList>
      </div>
    </div>
  </template>
}
